import { render, staticRenderFns } from "./SocietyHome.vue?vue&type=template&id=644b588e&scoped=true&"
import script from "./SocietyHome.vue?vue&type=script&lang=js&"
export * from "./SocietyHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b588e",
  null
  
)

export default component.exports